import axios from 'axios';
import { rawreq,req } from './axiosFun';

/**
 *  线下课程
 **/
// 列表
export const getCourseList = (params) => { return req("post", "/api/course/queryByPage", params) };
// 新增
export const addCourse = (params) => { return req("post", "/api/course/add", params) };
// 编辑
export const editCourse = (params) => { return req("post", "/api/course/edit", params) };
// 删除
export const deleteCourseById = (id) => { return rawreq("get", "/api/course/deleteById?id=" + id, {}) };


/*
*  课程表管理
* */

// 列表
export const getCourseTableList = (params) => { return req("post", "/api/lesson/queryByPage", params) };
// 详情
export const queryCourseById = (id) => { return rawreq("get", "/api/lesson/queryById?id=" + id, {}) };
// 编辑
export const editCourseTable = (params) => { return req("post", "/api/lesson/edit", params) };
// 删除
export const deleteCourseTableById = (id) => { return rawreq("get", "/api/lesson/deleteById?id=" + id, {}) };
// 删除
export const courseExportDetail = (id) => { return rawreq("get", "/api/lesson/exportDetail?id=" + id, {}) };
// 获取签到二维码
export const generateCode = (params) => { return rawreq("get", "/api/lesson/generate?classId=" + params.classId + "&courseId=" + params.courseId +"&roomId=" + params.roomId, {}) };



// WEBPACK FOOTER //
// ./src/api/course.js